<template>
  <section class="content">
    <!--<template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type === 'success' || alert.type === 'warning'" class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{`alert_${alert.type}` | translate}}!</h4>
        <p v-if="alert.type !== 'danger'">
          {{alert.message}}
        </p>
        <ul v-else>
          <li v-for="e in alert.message">
            {{e}}
          </li>
        </ul>
      </b-alert>
    </template>-->
    <template v-if="notFound">
      <div class="error-page">
        <h2 class="headline text-danger"> 404</h2>
        <div class="error-content">
          <h3><i class="fa fa-warning text-danger"></i> Oops! Order not found.</h3>
          <p>
            We could not find the order you were looking for.
            Meanwhile, you may <a href="/home">return to dashboard</a> or try using the search form.
          </p>
          <form @submit.prevent="$router.push(`/orders/${goto}`)" class="search-form">
            <div class="input-group">
              <input type="text" name="search" class="form-control" :placeholder="'goto_order' | translate" v-model="goto">
              <div class="input-group-btn">
                <button type="submit" name="submit" class="btn btn-danger"><i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </form>
          <br>
          <form @submit.prevent="goToMp()" class="search-form">
            <div class="input-group">
              <input type="text" name="search" class="form-control" placeholder="zu MP ID springen" v-model="gotoMP">
              <div class="input-group-btn">
                <button type="submit" name="submit" class="btn btn-danger"><i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row">
        <order-history :transitions="selectedLine.transitions" :main="false" :name="'historyModal'"></order-history>
        <order-history :transitions="order.transitions" :main="false" :name="'orderHistoryModal'"></order-history>
        <cancel-modal @action="cancelOrder($event)" :externalOrder="order.merchant_external_order"></cancel-modal>
        <return-modal @action="sendReturn($event)"></return-modal>
        <refund-modal @action="sendRefund($event)" @alert="alertError($event)"></refund-modal>
        <edit-modal v-if="order.customer && order.customer !== null" :address="editAddress" :client="order.customer" :id="$route.params.id" @alert="alert($event)"></edit-modal>
        <support-modal></support-modal>
        <div class="modal fade" id="label-history" tabindex="-1" role="dialog" aria-labelledby="item-history_ModalLabel" style="display: none;">
          <div class="modal-dialog modal-labels" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                <h4 class="modal-title"><i class="fa fa-truck mr-5"></i>{{'label_history' | translate}}</h4>
              </div>
              <div class="modal-body">
                <label-history :transitions="selectedLabelTransitions" :shipping="selectedShipping" :returnCode="selectedReturn"></label-history>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">{{'order_details' | translate}} <small>QB-ID: {{order.id}}</small></h3>
              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>
              </div>
            </div>
            <div class="box-controls">
              <div class="alert alert-danger mt-10 mb-10" v-if="order && order.status.label === 'mp_cancellation'" >
                <h4><i class="icon fa fa-warning"></i>Achtung - Diese Bestellung wurde von zalando storniert!</h4>
                <p>Bitte aktualisieren Sie den Bestand für diese Artikel in Ihrer Warenwirtschaft.</p>
              </div>
              <div class="alert alert-warning mt-10 mb-10" v-if="order && order.status.label === 'reserved' " >
                <h4><i class="icon fa fa-warning"></i>Achtung - Diese Bestellung ist noch nicht freigegeben!</h4>
                <p>Sie können Ihre Versandpapiere erst nach Freigabe erstellen.</p>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <h4>
                    {{'delivery_address' | translate}}
                    <button class="btn btn-info btn-xs pull-right" type="button" data-toggle="modal" v-show="showErrorButton" data-target="#edit-modal" aria-expanded="false" aria-controls="edit-billing">
                      <i class="fa fa-edit mr-5"></i>{{'edit' | translate | capitalize}}
                    </button>
                  </h4>
                  <hr>
                  <template v-if="order.customer && order.customer !== null">
                    <h5>{{order.customer.corrected_first_name !== ''? order.customer.corrected_first_name : order.customer.delivery_first_name}} {{order.customer.corrected_last_name !== ''? order.customer.corrected_last_name : order.customer.delivery_last_name}}</h5>
                    <p v-if="order.customer.corrected_street === ''">{{order.customer.delivery_address_line_1}}<br>
                      {{order.customer.delivery_address_line_2}}<br>{{order.customer.delivery_zip_code}} {{order.customer.delivery_city}}<br>{{order.customer.delivery_country | country}}
                      <span v-if="validDeliveryCountries.includes(order.customer.delivery_country)"><img class="img-responsive img-channel" :src="`/static/img/country_${order.customer.delivery_country}.svg`"></span>
                    </p>
                    <p v-else>
                      {{order.customer.corrected_street}} {{order.customer.corrected_street_number}} <br>
                      {{order.customer.corrected_zip}} {{order.customer.corrected_city}}
                    </p>
                    <p class="small text-muted">
                      <template v-if="order.customer.email">
                        <i class="fa fa-envelope mr-5"></i> <a :href="`mailto:${order.customer.email}`">{{order.customer.email}}</a>
                        <br>
                      </template>
                      <template v-if="order.customer.customer_phone_number && order.customer.customer_phone_number">
                        <i class="fa fa-phone mr-5"></i> <a :href="`tel:${order.customer.customer_phone_number}`">{{order.customer.customer_phone_number}}</a>
                      </template>
                    </p>
                  </template>
                  <template v-else>
                    <span class="text-warning"><i class="fa fa-info-circle mr-5"></i><strong>{{'address_message' | translate}}</strong></span>
                  </template>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                  <ul class="list-group list-group-unbordered">
                    <li class="list-group-item"><b>{{'order_number' | translate}}: </b>{{order.sales_channel === 'schuhede-mirapodo' || order.sales_channel === 'mirapodo' ? order.ext_order_id_addition : order.ext_order_id}}</li>
                    <li class="list-group-item"><b>{{'order_date' | translate}}: </b>{{order.order_date | orderDate}} <small class="text-muted">{{order.order_date | orderDate(true)}}</small></li>
                    <li class="list-group-item"><b>{{'order_total' | translate}}: </b>{{order.order_total | currency}}</li>
                    <li class="list-group-item"><b>{{'sales_channel' | translate}}: </b><i :class="getIcon(order.sales_channel)"></i> {{order.sales_channel| translate}}</li>
                    <li class="list-group-item"><b>Rating {{'points' | translate}}: </b>{{order.points}}</li>
                  </ul>
                </div>
              </div>
              <hr>
              <div :class="erpDisabled ? 'hidden row' : 'row'">
                <div class="form-group">
                  <label class="col-lg-6 col-md-6 col-sm-6 col-xs-12 control-label">Bestellung erneut an die Warenwirtschaft übermitteln.<br><small class="text-muted"><i class="fa fa-warning mr-5"></i>{{'erp_export' | translate}}</small></label>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <button :disabled="erpDisabledBtn" data-toggle="tooltip" @click="erpExport()" :data-title="'erp_export' | translate" data-original-title="" title="" class="btn btn-warning">ERP Export <i class="fa fa-share ml-5"></i></button>
                    <button type="button" data-toggle="modal" data-target="#orderHistoryModal" class="btn btn-sm btn-default pull-right"><i class="fa fa-clock-o mr-5"></i>{{'order' | translate}} {{'history' | translate}}</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-body">
              <template v-if="order.lines && order.lines.length > 0" v-for="(line, index) in order.lines">
                <div class="row">
                  <div class="col-xs-12 mb-10">
                    <span :class="line.status.style"><i :class="line.status.icon"></i>{{line.status.label | translate}}</span>
                    <span class="mr-5 text-muted pull-right"><strong>#{{index+1}}</strong></span>
                    <small class="text-success ml-5">
                      <span class="fa fa-info-circle mr-5"></span>{{'booked_from' | translate}}: {{`${filterStore(line.booked_store_id).name} - ${filterStore(line.booked_store_id).street} ${filterStore(line.booked_store_id).street_no} - ${filterStore(line.booked_store_id).zip_code} ${filterStore(line.booked_store_id).city}`}}
                    </small>
                  </div>
                  <div id="item-1">
                    <div class="clearfix margin"></div>
                    <div class="col-lg-1 col-md-2 col-sm-3 col-xs-6">
                      <a target="_blank" :href="`http://www.schuhe.de/schuh/s-cp${line.sku.split('-')[0]}.html`" >
                        <img class="img-preview" :src="line.image_url === null ? '/static/img/no-image-100x100.jpg' : line.image_url">
                      </a>
                    </div>
                    <div class="clearfix mb-10 visible-sm visible-xs"></div>
                    <div class="col-lg-4 col-md-10 col-sm-12 col-xs-12">
                      <strong>{{line.title}}</strong><br>
                      <small>{{'item_nr' | translate}}: <span class="special">{{line.wws_id}}</span>
                        <br>EAN: <span class="special">{{line.ean}}</span>
                        <br>{{'size' | translate}}: <span class="special">{{line.wws_size}}</span>
                        <br>{{'color' | translate}}: <span class="special">{{line.wws_color}}</span>
                      </small>
                    </div>
                    <div class="clearfix mb-10 visible-md visible-xs"></div>
                    <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12">
                      <strong>{{'item_price' | translate}}: </strong><span :class="[parseFloat(line.item_price) >= parseFloat(line.original_item_price) ? 'text-success' : 'text-danger']">{{line.item_price | currency}}</span><br>
                      <strong>Original-{{'price' | translate}}: </strong><span>{{line.original_item_price | currency}}</span><br>
                      <strong>MwSt.: </strong>{{`${line.tax_value} %`}}<br>
                      <strong>{{'shipping' | translate}}: </strong>{{line.shipping_price | currency}}
                    </div>
                    <div class="clearfix mb-10 visible-xs"></div>
                    <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12">
                      <template v-if="line.reductions && line.reductions.length > 0">
                        <strong><i class="fa fa-warning mr-5 text-additional"></i>{{'price_reduction' | translate}}:</strong>
                        <ul class="text-additional small list-unstyled">
                          <li v-for="r in line.reductions">{{'refund_amount' | translate}}: - {{r.refund_amount | currency}}</li>
                          <li><strong>{{'amount' | translate}}: </strong>{{line.refundable_amount | currency}}</li>
                        </ul>
                      </template>
                    </div>
                    <div class="clearfix mb-10 visible-xs"></div>
                    <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <strong><i class="fa fa-schuhe mr-5"></i>SKU: </strong><a class="underline text-primary" target="_blank" :href="`http://www.schuhe.de/schuh/s-cp${line.sku.split('-')[0]}.html`" >{{line.sku}}</a><br>
                      <template v-if="order.sales_channel === 'schuhede-zalando'">
                        <strong><i class="fa fa-zalando mr-5"></i>SKU: </strong><a class="underline text-primary" target="_blank" :href="`http://www.zalando.de/kinder/?q=${getZalandoCode(line.mp_item_id)}`">{{getZalandoCode(line.mp_item_id)}}</a>
                      </template>
                      <template v-if="order.sales_channel === 'schuhede-amazon' && line.mp_item_id_addition !== ''">
                        <strong><i class="fa fa-amazon mr-5"></i>SKU: </strong><a class="underline text-primary" target="_blank" :href="`https://www.amazon.de/schuhe/dp/${line.mp_item_id_addition}`">{{line.mp_item_id_addition}}</a><br />
                      </template>
                    </div>
                    <div class="clearfix mb-10"></div>
                    <div class="col-xs-12">
                      <div class="box-controls">
                        <div class="row">
                          <div class="col-lg-3 col-md-4 col-xs-12">
                            <div   class="btn-group no-padding btn-sm">
                              <button :disabled="getLabelTransitions(order.shippings, line.shipping_id).length === 0" type="button" data-toggle="modal" data-target="#label-history" class="btn btn-sm btn-default" @click="prepareLabelHistory(line)"><i class="fa fa-truck mr-5"></i>{{'label_history' | translate}}</button>
                              <button type="button" data-toggle="modal" data-target="#historyModal" class="btn btn-sm btn-default" @click="() => {selectedLine = line}"><i class="fa fa-clock-o mr-5"></i>{{'item_history' | translate}}</button>
                              <div class="input-group-btn">
                                <button :disabled="checkDisabled(line.status_transitions)" type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false">{{'options' | translate}}<span class="fa fa-caret-down ml-5"></span></button>
                                <ul class="dropdown-menu">
                                  <li v-if="line.status_transitions.returnable"><a class="text-warning" @click.prevent="openReturnModal(line.id)" href="#" data-toggle="modal" data-target="#return-modal"><i class="fa fa-reply"></i> {{'return' | translate}}</a></li>
                                  <li v-if="line.status_transitions.cancelable"><a class="text-danger"  @click.prevent="openCancelModal(line.id, line.id)" href="#" data-toggle="modal" data-target="#cancel-modal"><i class="fa fa-ban"></i>{{'cancel_order' | translate}}</a></li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-9 col-md-8 col-xs-12">
                            <span v-if="order.status.label === 'mp_cancellation_status'" class="btn-sm text-primary"><strong>{{'reason_for_cancel' | translate}}: {{'mp_cancelled_reason' | translate}}</strong></span>
                            <span v-else-if="line.shipping_id > 0 && line.return_id === 0" class="btn-sm text-success"><strong>{{'sender' | translate}}: {{`${filterStore(line.store_id).name} - ${filterStore(line.store_id).street} ${filterStore(line.store_id).street_no} - ${filterStore(line.store_id).zip_code} ${filterStore(line.store_id).city}`}}</strong></span>
                            <div v-else-if="line.cancellation_id === 0 && line.return_id === 0" class="input-group input-sm no-padding">
                              <span class="input-group-addon"><i class="fa fa-truck fa-flip-horizontal mr-5"></i>{{'sender' | translate}}</span>
                              <select class="form-control input-sm" v-model="line.store_id" @click.prevent="updateStore(line)">
                                <option v-for="store in $store.getters.stores" :value="store.id" class="normal">{{store.name}} - {{store.street}} {{store.street_no}}, {{store.zip_code}} {{store.city}}</option>
                              </select>
                            </div>
                            <template v-else-if="line && order.return_service_id === null && line.return_id > 0">
                              <span class="btn-sm text-success"><strong>{{'sender' | translate}}: {{`${filterStore(line.store_id).name} - ${filterStore(line.store_id).street} ${filterStore(line.store_id).street_no} - ${filterStore(line.store_id).zip_code} ${filterStore(line.store_id).city}`}}</strong></span>
                              <span class="btn-sm text-warning"><strong>{{'reason_for_return' | translate}}: {{getReason(line.return_id, order.returns).reason  | translate}}</strong></span>
                            </template>
                            <span v-else-if="line && line.cancellation_id" class="btn-sm text-danger"><strong>{{'reason_for_cancel' | translate}}: {{getReason(line.cancellation_id, order.cancellations).reason  | translate}}</strong></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr v-if="order.lines.length > 1 && index !== order.lines.length -1">
              </template>
            </div>
            <div class="box-footer">
              <div class="row" style="margin-bottom:30px;">
                <div class="col-md-4 col-sm-6 col-xs-12" v-if="show">
                  <div class="form-group">
                    <label>{{'parcel_options' | translate}}</label>
                    <select class="form-control" v-model="parcel">
                      <option class="normal" v-for="opt in parcelOptions" :value="opt.id">{{opt.carrier}} {{opt.parcel_type}} {{opt.weight}}KG ({{opt.length}}x{{opt.width}}x{{opt.height}})</option>
                    </select>
                  </div>
                </div>
                <div class="clearfix margin"></div>
                <template v-if="shippings && shippings.length > 0 && !showErrorButton">
                    <template v-for="(parcel, index) in shippings">
                      <div class="col-xs-12">
                        <div class="alert alert-warning mb-10" v-if="checkIfAustria(parcel.id)">
                          <div class="row">
                            <div class="col-xs-6">
                              <h2>Wichtige Informationen zur Bestellung:</h2>
                              <span>Um die Abholung der Bestellung und der zugehörigen Pakete zu gewährleisten müssen Sie bitte den Paketdienst DPD verständigen.<br/>
                          Geben Sie zur Abholung unsere Kundenummer <strong>625138228</strong> und Ihre Abholadresse an:
                          </span>
                            </div>
                            <div class="col-xs-6">
                              <h2>Depot 0625</h2>
                              <span>Lagermax Paketdienst GmbH, 5162 Obertrum, Fürnbuch 6<br/>
                          Telefon: <a href="tel:+43621266110">062126611-0</a><br/>
                          Email: <a href="mailto:depot0625@dpd.at">depot0625@dpd.at</a></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-12">
                        <div class="col-md-4 col-sm-6 col-xs-12">
                          <label>{{'tracking' | translate}}:</label><br>
                          <template v-for="label in parcel.labels">
                            <div class="btn-group">
                              <a type="button" :href="label.tracking_url" target="_blank" class="btn btn-default">
                                <i class="fa fa-qrcode mr-5"></i>{{label.type === 'shipping' ? 'order_tracking' : 'return_tracking' | translate}}
                              </a>
                            </div>
                          </template>
                          <div class="margin"></div>
                        </div>
                        <div class="col-md-8 col-sm-6 col-xs-12">
                          <label>{{'parcel' | translate}} {{index + 1}} - {{'documents' | translate}}:</label><br>
                          <div class="btn-group mb-10">
                            <template v-for="label in parcel.labels">
                              <a type="button" class="btn btn-outline" :href="label.shipping_label_path"><i class="fa fa-file-text-o mr-5"></i>{{label.type === 'shipping'? 'shipping_label' : 'return_label' | translate}}</a>
                            </template>
                            <a v-if="parcel.delivery_information_path !== ''" type="button" class="btn btn-outline" :href="parcel.delivery_information_path"><i class="fa fa-file-text-o mr-5"></i>{{'delivery_information' | translate}}</a>
                            <a v-if="parcel.return_information_path !== ''" type="button" class="btn btn-outline" :href="parcel.return_information_path"><i class="fa fa-file-text-o mr-5"></i>{{'return_information' | translate}}</a>
                            <template v-if="order.sales_channel_id === 6 || order.sales_channel_id === 3">
                              <a type="button" class="btn btn-outline" href="https://s3.eu-central-1.amazonaws.com/production.qb-schuhe.de/misc/zalando-return/returnprogram.pdf"><i class="fa fa-file-text-o mr-5"></i>{{'z_return' | translate}}</a>
                            </template>
                          </div>
                          <div class="btn-group pull-right">
                            <a type="button" :href="parcel.combined_path_documents" class="btn btn-success btn-lg"><i class="fa fa-print mr-5"></i>{{'combined_documents' | translate}}</a>
                            <a type="button" :href="parcel.combined_path_shipping" class="btn btn-success btn-lg"><i class="fa fa-print mr-5"></i>{{'combined_shipping' | translate}}</a>
                          </div>
                        </div>
                      </div>
                      <hr v-if="shippings.length > 1 && index !== shippings.length -1">
                    </template>
                </template>
                <div class="col-md-8 col-sm-6 col-xs-12 text-right" v-else-if="show">
                  <button onclick="this.disabled=true" @click="createLabels()" class="btn btn-lg btn-success"><i class="fa fa-print mr-5"></i>{{'create' | translate}}</button>
                </div>
                <div class="text-center alert alert-warning" v-if="showErrorButton">
                  <span v-if="order.own_label_error==true">
                    {{'own_label_error_message_first' | translate}}
                    <p>
                      {{'own_label_error_message_second' | translate}}
                    </p>
                  </span>
                  <span v-else>
                    {{'error_label_address_message' | translate}}
                    <p>
                      {{'error_label_contact_us' | translate}}
                    </p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <order-notes :id="$route.params.id"></order-notes>
        </div>
      </div>
      <div class="overlay" v-show="loading">
        <img class="loading-gif" src="/static/img/blabla.svg"/>
      </div>
    </template>
  </section>
</template>
<script>
import OrderHistory from '../tools/OrderHistory.vue'
import LabelHistory from '../tools/LabelHistory.vue'
export default {
  data () {
    return {
      orderId: this.$store.getters.orderWithTokenId,
      goto: '',
      gotoMP: '',
      sent: false,
      notFound: false,
      showErrorButton: false,
      selectedLine: {},
      selectedLabelTransitions: {},
      selectedShipping: {},
      selectedReturn: {},
      shipStatus: '',
      shippings: {},
      cancellations: {},
      erpDisabled: false,
      erpDisabledBtn: false,
      counter: 0,
      formstate: {},
      show: false,
      invoiceForm: {},
      streetName: '',
      loading: false,
      streetNumber: '',
      parcel: this.$store.getters.parcelId,
      lineForCancel: 0,
      lineForReturn: 0,
      itemForCancel: 0,
      order: {
        billing_address_addition: '',
        billing_city: '',
        billing_country: '',
        billing_first_name: '',
        billing_last_name: '',
        billing_zip_code: '',
        company_id: '',
        created_at: '',
        currency: '',
        customer_email: '',
        customer_id: '',
        customer_phone_number: '',
        delivery_address: '',
        delivery_address_addition: '',
        delivery_city: '',
        delivery_country: '',
        delivery_first_name: '',
        delivery_last_name: '',
        delivery_zip_code: '',
        ext_order_id: '',
        id: '',
        sales_channel: 'schuhede',
        invoice_city: '',
        invoice_company: '',
        invoice_country: '',
        invoice_name: '',
        invoice_street: '',
        invoice_street_no: '',
        invoice_zip_code: '',
        lines: [],
        label_care_of: '',
        label_city: '',
        label_company: '',
        label_country: '',
        label_name: '',
        label_street: '',
        label_street_no: '',
        label_zip_code: '',
        number_of_lines: '',
        order_date: '',
        order_total: '',
        order_type: '',
        payment_method: '',
        sales_channel_id: '',
        shipping_city: '',
        shipping_country: '',
        shipping_name: '',
        shipping_street: '',
        shipping_street_no: '',
        shipping_zip_code: '',
        status: {},
        items: {}
      },
      editAddress: {
        corrected_company: '',
        corrected_first_name: '',
        corrected_last_name: '',
        corrected_zip: '',
        corrected_city: '',
        corrected_street: '',
        corrected_street_number: '',
        corrected_care_of: ''
      },
      validDeliveryCountries: ['DE', 'AT', 'FR', 'NL', 'UK', 'BE', 'ES', 'IT'],
      retryId: 0,
      parcelOptions: [],
      alerts: [],
      error: {},
      pepe () {
        this.updateOrder()
      },
      checkDefaultFields () {
        let shippingLabel = {
          label_name: this.order.label_name,
          label_care_of: this.order.label_care_of,
          label_street: this.order.label_street,
          label_street_no: this.order.label_street_no,
          label_city: this.order.label_city,
          label_zip_code: this.order.label_zip_code
        }
        let billingLabel = {
          invoice_name: this.order.invoice_name,
          invoice_care_of: this.order.invoice_care_of,
          invoice_street: this.order.invoice_street,
          invoice_street_no: this.order.invoice_street_no,
          invoice_city: this.order.invoice_city,
          invoice_zip_code: this.order.invoice_zip_code
        }
        let alertMsg = 'There is a problem in the billing address format. Please edit the address manually to proceed the order.'
        let alert = {type: 'danger', message: alertMsg}
        for (let x in shippingLabel) {
          if (shippingLabel[x] === '') {
            if (x === 'label_care_of' && (shippingLabel.label_street === 'PACKSTATION' || shippingLabel.label_street === 'POSTFILIALE')) {
              this.$store.commit('pushAlert', alert)
            } else if (x !== 'label_care_of') {
              this.$store.commit('pushAlert', alert)
            }
          }
        }
        for (let y in billingLabel) {
          if (billingLabel[y] === '') {
            if (y === 'invoice_care_of' && (billingLabel.invoice_street === 'PACKSTATION' || billingLabel.invoice_street === 'POSTFILIALE')) {
              this.$store.commit('pushAlert', alert)
            } else if (y !== 'label_care_of') {
              this.$store.commit('pushAlert', alert)
            }
          }
        }
      }
    }
  },
  components: {
    orderHistory: OrderHistory,
    labelHistory: LabelHistory
  },
  methods: {
    checkIfAustria (shipping) {
      let line = this.order.lines.find(l => {
        return l.shipping_id === shipping
      })
      let store = this.$store.getters.stores.find(s => {
        return s.id === line.booked_store_id
      }) || {name: 'zugeordnete Filiale wurde nicht gefunden', street: '', street_no: '', city: '', zip_code: ''}
      return store.shipping_country === 'AT'
    },
    prepareLabelHistory (item) {
      this.selectedLabelTransitions = this.order.shippings.filter(e => e.id === item.shipping_id)[0].labels
      this.selectedShipping = this.getShipping(item.shipping_id, 'shipping')
      this.selectedReturn = this.getShipping(item.shipping_id, 'return')
    },
    getLabelTransitions (shippings, id) {
      let ret = []
      shippings.forEach(s => {
        if (s.id === id) {
          s.labels.forEach(l => {
            ret.push({type: l.type, transitions: l.transitions})
          })
        }
      })
      return ret
    },
    getIcon (mp) {
      return mp === 'schuhede' ? 'fa fa-schuhe' : `fa fa-${mp.split('-')[1]}`
    },
    getZalandoCode (url) {
      let aux = url.split('-')
      return `${aux[0]}-${aux[1].substr(0, 3)}`
    },
    getShipping (id, type) {
      for (let p in this.shippings) {
        if (this.shippings[p].id === id) {
          for (let l in this.shippings[p].labels) {
            if (this.shippings[p].labels[l].type === type) {
              return this.shippings[p].labels[l].tracking_url
            }
          }
        }
      }
    },
    sendRefund (data) {
      API.put(`/orders/line/${this.lineForRefund}/case`, data)
        .then(response => {
          let alert = {type: 'success', dismiss: 4, message: 'Case created successfully'}
          this.updateOrder()
          this.$store.commit('pushAlert', alert)
        })
    },
    cancelOrder (value) {
      API.put(`/orders/line/${this.lineForCancel}/cancel`, value)
        .then(response => {
          $('#closeCancelModal').click()
          this.updateOrder()
        }, error => {
          $('#closeCancelModal').click()
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
          this.updateOrder()
          this.$store.commit('pushAlert', alert)
        })
    },
    goToMp () {
      API.get(`/orders?ext_order_id=${this.gotoMP}`)
        .then(response => {
          if (response.data.data.length > 1 || response.data.data.length === 0) {
            this.$router.push('/orders/error')
          } else {
            this.$router.push(`/orders/${response.data.data[0].id}`)
          }
        })
    },
    checkLabelsCall () {
      API.get(`orders/${this.orderId}/shippings/check`)
        .then(response => {
          this.shipStatus = response.data.status
          if (response.data.status === 'done' || response.data.status === 'error') {
            this.loading = false
            if (response.data.status === 'error') {
              this.show = false
              this.showErrorButton = true
              this.getCustomer()
              this.updateOrder(true)
            } else {
              this.updateOrder()
            }
          } else {
            setTimeout(this.checkLabelsCall, 5000)
          }
        })
        .catch(error => {
          this.loading = false
        })
    },
    checkShippingError (data) {
      let ret = false
      data.forEach(d => {
        if (d.combined_path_shipping === '' || d.combined_path_documents === '') {
          ret = true
        }
      })
      return ret
    },
    createLabels () {
      API.put(`orders/${this.orderId}/ship`, {parcel_id: this.parcel})
        .then(response => {
          this.sent = true
          this.loading = true
          this.checkLabelsCall()
        })
        .catch(error => {
          if (this.$parent.checkError(error)) {
            let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
            this.$store.commit('pushAlert', alert)
          }
        })
    },
    checkDisabled (line) {
      let a = Object.keys(line).find(e => {
        return line[e] === true
      })
      return typeof a === 'undefined'
    },
    fieldClassName (field, key) {
      if (!field) {
        return ''
      }
      if ((field.$touched || field.$submitted) && field.$valid && !field.$pristine && this.order[key] !== '') {
        return 'has-success'
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return 'has-error'
      }
    },
    erpExport () {
      this.erpDisabledBtn = true
      API.get(`/orders/${this.order.id}/export`)
        .then(response => {
          let alert = {type: 'success', dismiss: 4, message: response.data.message}
          this.$store.commit('pushAlert', alert)
        })
        .catch(error => {
          let alert = {type: 'danger', dismiss: 4, message: ['E-rror']}
          this.$store.commit('pushAlert', alert)
        })
    },
    filterStore (id) {
      let stores = this.$store.getters.stores
      for (let x in stores) {
        if (stores[x].id === id) {
          return stores[x]
        }
      }
    },
    getCancellation (id) {
      let c = this.order.cancellations
      for (let x in c) {
        if (c[x].id === id) {
          return c[x]
        }
      }
    },
    getReason (needle, haystack) {
      for (let x in haystack) {
        if (haystack[x].id === needle) {
          return haystack[x]
        }
      }
    },
    infoLabels (parcel) {
      return parcel.return_information_path !== '' && parcel.delivery_information_path !== '' && parcel.combined_path !== ''
    },
    getStatus (item) {
      if (item.transitions.length > 0) {
        let status = item.transitions[item.transitions.length - 1].transition
        if (status === 'mp_cancellation') {
          return {label: 'mp_cancellation_status', style: 'label label-primary', icon: 'fa fa-exclamation-triangle mr-5'}
        }
        if (status === 'initial') {
          return {label: 'reserved', style: 'label label-primary', icon: 'fa fa-bookmark mr-5'}
        }
        if (status === 'canceled' || status === 'cancelled') {
          return {label: 'canceled', style: 'label label-danger', icon: 'fa fa-ban mr-5'}
        }
        if (!item.return_service_id && status === 'returned') {
          return {label: 'returned_status', style: 'label label-warning', icon: 'fa fa-reply mr-5'}
        }
        if (status === 'shipped' || status === 'fulfilled') {
          return {label: 'shipped', style: 'label label-success', icon: 'fa fa-check mr-5'}
        }
        if (status === 'open' || status === 'approved') {
          return {label: 'open', style: 'label label-info', icon: 'fa fa-sign-in mr-5'}
        }
      } else {
        return {label: 'canceled', style: 'label label-danger', icon: 'fa fa-ban mr-5'}
      }
    },
    getLineStatus (line, returnServiceId = null) {
      if (line.case && Object.keys(line.case).length > 0) {
        if (status.case.status === 'accepted') {
          return ['partial_refund_accepted', 'label label-primary', 'fa fa-check mr-5']
        } else {
          if (status.case.status === 'declined') {
            return ['partial_refund_declined', 'label label-danger', 'fa fa-ban mr-5']
          }
        }
        return ['partial_refunded', 'label label-primary', 'fa fa-reply mr-5']
      }
      if (line.cancellation_id > 0) {
        return {label: 'canceled', style: 'label label-danger', icon: 'fa fa-ban mr-5'}
      }
      if (!returnServiceId && line.return_id > 0) {
        return {label: 'returned', style: 'label label-warning', icon: 'fa fa-reply mr-5'}
      }
      if (line.shipping_id > 0) {
        return {label: 'shipped', style: 'label label-success', icon: 'fa fa-check mr-5'}
      }
      return {label: 'processing', style: 'label label-info', icon: 'fa fa-ellipsis-h mr-5'}
    },
    openCancelModal (item, line) {
      this.itemForCancel = item
      this.lineForCancel = line
    },
    openReturnModal (line) {
      this.lineForReturn = line
    },
    openRefundModal (line) {
      this.lineForRefund = line
    },
    sendReturn (value) {
      API.put(`/orders/line/${this.lineForReturn}/return`, {status: value[0], reason: value[1]})
        .then(response => {
          $('#closeReturnModal').click()
          $('#abc').attr('disabled', false)
          this.updateOrder()
        })
        .catch(error => {
          $('#closeReturnModal').click()
          $('#abc').attr('disabled', false)
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
          this.updateOrder()
          this.$store.commit('pushAlert', alert)
        })
    },
    getCustomer () {
      API.get(`orders/${this.orderId}`)
        .then(response => {
          this.order.customer = response.data.customer
          this.editAddress = response.data.customer
        })
    },
    alert (value) {
      let alert
      this.checkLabelsCall()
      if (value.status === 200 || value.status === 204 || value.status === 202) {
        alert = {dismiss: 4, type: 'success', message: 'Update Successful', icon: 'icon fa fa-check', show: true}
      } else if (value.status === 0) {
        alert = {dismiss: 4, type: 'warning', message: 'Not modified', icon: 'icon fa fa-warning', show: true}
      } else {
        alert = {dismiss: 4, type: 'danger', message: 'There was an error: ' + value.data.message, icon: 'icon fa fa-ban', show: true}
      }
      this.$store.commit('pushAlert', alert)
    },
    updateOrder (labelError = false) {
      if (!labelError) {
        this.alerts = []
        this.showErrorButton = false
      }
      this.show = false
      this.retryId = 0
      this.itemForCancel = 0
      this.lineForCancel = 0
      this.cancelReason = 'out_of_stock'
      API.get(`/orders/${this.orderId}`)
        .then(response => {
          this.order = response.data
          this.order.status = this.getStatus(this.order)
          let main = []
          this.order.transitions.forEach(t => {
            let date = t.date.split(' ')
            if (!(date[0] in main)) {
              main[date[0]] = {date: date[0], transitions: []}
            }
            main[date[0]].transitions.push({event: `${t.transition}_tr`, time: date[1]})
          })
          this.order.transitions = []
          for (let k in main) {
            this.order.transitions.push(main[k])
          }
          this.order.lines.forEach(y => {
            let aux = []
            if (this.order.status.label === 'open' || this.order.status.label === 'shipped') {
              y.status = this.getLineStatus(y, this.order.return_service_id)
            } else {
              y.status = this.order.status
            }
            if (y.shipping_id === 0 && y.cancellation_id === 0) {
              this.show = true
            }
            if (y.transitions.length > 0) {
              y.transitions.forEach(t => {
                let date = t.date.split(' ')
                if (!(date[0] in aux)) {
                  aux[date[0]] = {date: date[0], transitions: []}
                }
                aux[date[0]].transitions.push({event: `${t.transition}_ln`, time: date[1]})
              })
              y.transitions = []
              for (let a in aux) {
                y.transitions.push(aux[a])
              }
            }
          })
          if (this.order.status.label === 'initial' || this.order.status.label === 'mp_cancellation_status' || this.order.status.label === 'shipped') {
            this.show = false
          }
          this.shippings = this.order.shippings
          if (this.checkShippingError(this.shippings)) {
            if (!labelError) {
              this.checkLabelsCall()
            }
          }
          this.checkDefaultFields()

          API.get(`/orders/parcel-options/${this.orderId}`)
            .then(response => {
              this.parcelOptions = response.data
            })
            .catch(error => {
              this.notFound = error.response.status === 404
              let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
              if (error.response.status !== 404) {
                this.$store.commit('pushAlert', alert)
              }
            })
        })
        .catch(error => {
          this.notFound = error.response.status === 404
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
          error.response.status === 404 ? '' : this.$store.commit('pushAlert', alert)
        })
    },
    updateStore (line) {
      API.put(`/orders/line/${line.id}/store`, {store_id: line.store_id})
    },
    checkErpDisabled () {
      if (this.$store.getters.user.erp_system_name.includes('etos')) {
        this.erpDisabled = true
      }
    }
  },
  mounted () {
    if (this.orderId === 0) {
      this.$store.dispatch('logout')
    } else {
      this.updateOrder()
      this.checkErpDisabled()
    }
  },
  watch: {
  }
}
</script>
<style>
  .special {
    font-size: 0.975rem;
    font-weight: bold;
  }
  .overlay {
    z-index: 50;
    background: rgba(33,34,40,.75);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 110%;
  }
  .overlay-text{
    position: absolute;
    top: 54%;
    left: 49%;
    margin-left: -1rem;
    margin-top: -1rem;
  }
  .overlay > .fa {
    position: absolute;
    top: 50%;
    left: 57%;
    margin-left: -1rem;
    margin-top: -1rem;
    color: currentColor;
    font-size: 2rem;
    opacity: 0.65;
  }
  select option.danger {
    margin: 40px;
    background:rgb(86, 32, 27);
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  }
  select option.normal {
    margin: 40px;
    background:rgb(32, 34, 39);
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  }
  select option.warning {
    margin: 40px;
    background:#5e4219;
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  }
</style>
<style scoped>
  .loading-gif {
    display: block;
    width: 5%;
    top: 42%;
    left: 50%;
    position: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/SingleOrderWithToken.vue